// extracted by mini-css-extract-plugin
export var orderDetails = "_jl-2";
export var orderImage = "_jl-1";
export var orderMeta = "_jl-3";
export var orderSummary = "_jl-0";
export var rightArrow = "_jl-4";